import React from 'react';
import PropTypes from 'prop-types';
import { DECODING_SUBSCORE_MEASURES_LABELS } from '../../../../constants/reading/MeasuresConstants';
import { ICON } from '../../../../constants/shared/CommonConstants';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const { DONE, CLOSE } = ICON;

const renderQuestions = (categoryOfQuestions, itemLevelDetails) =>
    categoryOfQuestions.map(({ questionId, wordsOfQuestion }, index) => {
        const { responseId, correct } = itemLevelDetails[questionId];
        const questionClass = index % 2 === 0 ? 'secondary-question' : '';

        return (
            <div key={generateReactKey(index, questionId)} className={`question ${questionClass}`}>
                {wordsOfQuestion.map(({ wordId, wordText, isCorrect }) => {
                    const wordClass = responseId === wordId ? 'choosen-by-student' : '';

                    return (
                        <div key={generateReactKey(wordId)} className="word-wrapper">
                            <span className={`word ${wordClass}`}>
                                {wordText}
                                {isCorrect && DONE}
                            </span>
                        </div>
                    );
                })}
                <span>{correct ? DONE : CLOSE}</span>
            </div>
        );
    });

const DecodingProbeDetailsContent = ({ result, categoriesOfQuestions }) => {
    return Object.keys(categoriesOfQuestions).map(categoryKey => {
        const { score, maxScore } = result.measureSubscores[categoryKey];

        return (
            <section key={generateReactKey(categoryKey)} className="category">
                <div className="d-flex justify-content-between">
                    <h5 className="category-label">
                        {DECODING_SUBSCORE_MEASURES_LABELS[categoryKey]}
                    </h5>
                    <span className="category-score">
                        Score: <b>{`${score}/${maxScore}`}</b>
                    </span>
                </div>
                <div className="category-content">
                    {renderQuestions(categoriesOfQuestions[categoryKey], result.itemLevelDetails)}
                </div>
            </section>
        );
    });
};

DecodingProbeDetailsContent.defaultProps = {
    result: {},
    categoriesOfQuestions: {},
};

DecodingProbeDetailsContent.propTypes = {
    result: PropTypes.object,
    categoriesOfQuestions: PropTypes.object,
};

export default DecodingProbeDetailsContent;
